import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, CardFooter, Input, Label } from 'reactstrap';
import UploadCampaign from '../../Components/UploadCampaign';
import VersionDetails from '../../Components/VersionDetails';
import { useDispatch, useSelector } from 'react-redux';
import { createVersion } from '../../../../../slices/campaigns/thunk';
import { resetVersionDetails, setFilteredTemplateCreatives } from '../../../../../slices/campaigns/reducer';
import { createSelector } from 'reselect';
import DropFileTable from '../../Components/DropFileTable';
import { setPreloader } from '../../../../../slices/layouts/reducer';
import { sortByWidth } from '../../../../../slices/helper';
function EmptyPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetVersionDetails());
  }, []);

  const selectUploadedFiles = createSelector((state) => state.Upload, (state) => ({
    uploadedFiles: state.uploadedFiles,
    uploadLimits: state.uploadLimits,
  }));
  const selectState = createSelector(state => state.Campaign, state => state.filteredTemplateCreatives);
  const filteredTemplateCreatives = useSelector(selectState);
  const {uploadedFiles, uploadLimits} = useSelector(selectUploadedFiles);
  const [isSubmit, setIsSubmit] = useState(false);

  function handleSubmit() {
    setIsSubmit(true);
  }
  async function submitFunc(values) {
    dispatch(setPreloader(true));   
    await dispatch(createVersion(values));
    dispatch(setPreloader(false));
    setIsSubmit(false);
  }

  useEffect(() => {
    dispatch(setFilteredTemplateCreatives(uploadedFiles));
  }, [uploadedFiles]);

  return (
    <Row>
      <Col xxl={8}>
        <Card style={{minHeight: "330px"}}>
          <CardHeader>
            Upload Images
          </CardHeader>
          <CardBody>
            <UploadCampaign limits={(uploadLimits || []).find(item => item.type === "image")}/>
            <DropFileTable />
          </CardBody>
        </Card>
      </Col>
      <Col xxl={4}>
        <Card style={{minHeight: "330px"}}>
          <CardHeader>Version Details</CardHeader>
          <CardBody>
            <VersionDetails isSubmit={isSubmit} submitFunc={async (values) => await submitFunc(values)} />
            {(uploadedFiles || []).length > 0 ?
              <div className='w-100 d-flex justify-content-end gap-1'>
                <button type='submit' className='btn btn-success mt-3 ms-auto me-0' onClick={handleSubmit}>Add Version</button>
              </div>
              : null}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default EmptyPage
